import React from 'react';
import { Button, Container, Form, InputGroup, Label, Row } from 'reactstrap';
import { Field, Fields } from 'redux-form';
import { LinkContainer } from 'react-router-bootstrap';
import { compact, omit, pick } from 'underscore';
import URI from 'urijs';
import cx from 'classnames';

// components
import { ucFirst } from '../../../utilities';
import { cleanQuery } from '../../../middleware/client';
import PriceFilter from '../../../components/form/filter/price-filter';
// import BedFilter from '../../../components/form/filter/bed-filter';
// import BathFilter from '../../../components/form/filter/bath-filter';
import { LocationTypeAheadField } from '../../../components/form/field/location-typeahead';
import BuildingTypeFilter from '../../../components/form/filter/building-type-filter';
import SaleFilter from '../../../components/form/filter/sale-filter';
import CommercialTypeFilter from '../../../components/form/filter/commercial-type-filter';
import SqftFilter from '../../../components/form/filter/sqft-filter';

import fieldButtonDropdown from '../../../decorators/field-button-dropdown';

// modules
import BS from '../../../theme/Bootstrap';
import styles from '../../Containers.module.scss';

const PriceDropdown = fieldButtonDropdown(PriceFilter);
// const BedDropdown = fieldButtonDropdown(BedFilter);
// const BathDropdown = fieldButtonDropdown(BathFilter);
const BuildingTypeDropdown = fieldButtonDropdown(BuildingTypeFilter);
const CommercialTypeDropdown = fieldButtonDropdown(CommercialTypeFilter);
const SaleDropdown = fieldButtonDropdown(SaleFilter);
const SqftDropdown = fieldButtonDropdown(SqftFilter);

const CommercialSearch = props => {
  const { handleSubmit, /*onFilterClick,*/ initialValues, basePath } = props;
  const allValues = cleanQuery(omit(initialValues, 'view', 'agentId', 'propertyClass'));
  const advancedOnlyValues = omit(
    allValues,
    'address',
    'minPrice',
    'maxPrice',
    'minArea',
    'maxArea',
    'commercialType',
    'propertyType',
    'transactionType'
  );
  const moreClassName = cx({
    'badge-dirty': Object.keys(advancedOnlyValues).length > 0
  });
  const resetClassName = cx({
    'badge-dirty': Object.keys(allValues).length > 0
  });
  const propertyClass = initialValues.propertyClass || 'residential';

  return (
    <Row
      className={cx(
        styles.searchHeader,
        BS.pt3,
        styles['searchHeader' + ucFirst(propertyClass)]
      )}
    >
      <Container>
        <Form inline className={cx(BS.alignItemsStart)} onSubmit={handleSubmit}>
          {props.children}
          <InputGroup className={cx(BS.inputGroupGutter, BS.pb2, BS.mrSm2)}>
            <Label for="address" className="sr-only">
              Address, City, Neighborhood, Zip
            </Label>
            <LocationTypeAheadField
              propertyClass="commercial"
              showSubmit
              submitClassName={cx(BS.ml2)}
            />
          </InputGroup>
          <InputGroup className={cx(BS.inputGroupGutter, BS.pb2)}>
            <LinkContainer
              to={URI(`${basePath}/advanced`)
                .search(cleanQuery(initialValues))
                .toString()}
            >
              <Button color="dark-blue" outline className={cx(moreClassName, BS.dMdNone)}>
                Filters
              </Button>
            </LinkContainer>
          </InputGroup>
          <InputGroup className={cx(BS.inputGroupGutter, BS.dNone, BS.dSmFlex, BS.pb2)}>
            <Fields
              names={['minPrice', 'maxPrice']}
              component={PriceDropdown}
              label="Price"
              showSelects
            />
            <Fields
              names={['minArea', 'maxArea']}
              component={SqftDropdown}
              label="Size"
            />
            <Field
              name="commercialType"
              format={value => {
                return compact((value || '').trim().split(','));
              }}
              normalize={value => {
                return value.join(',');
              }}
              component={CommercialTypeDropdown}
              label="Type"
              numCols={1}
              numInnerCols={1}
            />
            <Field
              name="propertyType"
              format={value => {
                return compact((value || '').trim().split(','));
              }}
              normalize={value => {
                return value.join(',');
              }}
              component={BuildingTypeDropdown}
              type="commercial"
              label="Property Type"
              numCols={2}
              numInnerCols={1}
              dropdownSize="lg"
            />
            <Field
              name="transactionType"
              format={value => {
                return compact((value || '').trim().split(','));
              }}
              normalize={value => {
                return value.join(',');
              }}
              component={SaleDropdown}
              label="Sale/Lease"
              numCols={2}
              numInnerCols={1}
            />
            <LinkContainer
              to={URI(`${basePath}/advanced`)
                .search(cleanQuery(initialValues))
                .toString()}
            >
              <Button color="white" className={moreClassName}>
                More Filters
              </Button>
            </LinkContainer>
            <LinkContainer
              to={URI(`${basePath}`)
                .search({
                  ...pick(initialValues, 'view', 'pageSize'),
                  propertyClass:
                    propertyClass !== 'residential' ? propertyClass : undefined,
                  page: 1
                })
                .toString()}
            >
              <Button color="white-red" className={resetClassName}>
                Reset Filters
              </Button>
            </LinkContainer>
          </InputGroup>
        </Form>
      </Container>
    </Row>
  );
};

export default CommercialSearch;



// WEBPACK FOOTER //
// ./src/containers/PropertySearch/Search/CommercialSearch.js